/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace chi
*/
var chi = {};

/**
* @name cdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/cdf}
*/
import cdf from './../../../../base/dists/chi/cdf';
setReadOnly( chi, 'cdf', cdf );

/**
* @name Chi
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/ctor}
*/
import Chi from './../../../../base/dists/chi/ctor';
setReadOnly( chi, 'Chi', Chi );

/**
* @name entropy
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/entropy}
*/
import entropy from './../../../../base/dists/chi/entropy';
setReadOnly( chi, 'entropy', entropy );

/**
* @name kurtosis
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/kurtosis}
*/
import kurtosis from './../../../../base/dists/chi/kurtosis';
setReadOnly( chi, 'kurtosis', kurtosis );

/**
* @name logpdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/logpdf}
*/
import logpdf from './../../../../base/dists/chi/logpdf';
setReadOnly( chi, 'logpdf', logpdf );

/**
* @name mean
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/mean}
*/
import mean from './../../../../base/dists/chi/mean';
setReadOnly( chi, 'mean', mean );

/**
* @name mode
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/mode}
*/
import mode from './../../../../base/dists/chi/mode';
setReadOnly( chi, 'mode', mode );

/**
* @name pdf
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/pdf}
*/
import pdf from './../../../../base/dists/chi/pdf';
setReadOnly( chi, 'pdf', pdf );

/**
* @name quantile
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/quantile}
*/
import quantile from './../../../../base/dists/chi/quantile';
setReadOnly( chi, 'quantile', quantile );

/**
* @name skewness
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/skewness}
*/
import skewness from './../../../../base/dists/chi/skewness';
setReadOnly( chi, 'skewness', skewness );

/**
* @name stdev
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/stdev}
*/
import stdev from './../../../../base/dists/chi/stdev';
setReadOnly( chi, 'stdev', stdev );

/**
* @name variance
* @memberof chi
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chi/variance}
*/
import variance from './../../../../base/dists/chi/variance';
setReadOnly( chi, 'variance', variance );


// EXPORTS //

export default chi;
